import get from 'lodash/get';
import { Product, Hash, ConfigurationParameters, Variant } from '../interfaces';

export const productTransformer = ({ locale }: ConfigurationParameters) => (
  item: Hash
): Product => {
  return {
    slug: get(item, 'key', ''),
    image: get(item, ['masterVariant', 'images', 0, 'url'], ''),
    title: get(item, ['name', locale || 'en'], ''),
    sku: get(item, ['masterVariant', 'sku'], ''),
    variants: get(item, ['variants'], []),
  };
};

export const variantTransformer = () => (item: Hash): Variant => {
  return {
    image: get(item, ['images', 0, 'url'], ''),
    sku: get(item, ['sku'], ''),
  };
};
